// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f64937ce","977":"cb316a14"}[chunkId] + ".chunk.js";
};